const name = 'circle-n';

const contents = '<path fill="#FFF" d="M24.661 55h-5.137V26.829h5.137l12.76 19.388h.415l-.497-7.457V26.829h5.137V55h-5.469L24.661 36.191h-.414l.414 6.878z"/>';

/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'N',
};

export default icon;
